import { Component, OnInit, Input } from '@angular/core';
import { SesssionActivityService } from '../_services/sesssion-activity.service';
import { AuthService } from '../_services/auth.service';

export interface IDoingStage {
  title: string;
  routerLink: any;
  disabled: boolean;
}

@Component({
  selector: 'app-doing-status',
  templateUrl: './doing-status.component.html',
  styleUrls: ['./doing-status.component.css']
})

export class DoingStatusComponent implements OnInit {
  @Input() projectTitle: string = '';
  @Input() doingStatusSelected: string = '';
  @Input() projectId: any = '';
  doingStage: number = 1;
  inventionDrawingStatus: string = 'No';
  percentage;
  userSession;
  userDetailsId: 0;

  stages: IDoingStage[] = [
    { title: 'Basic Invention Details', routerLink: '/main/basicInventionDetails', disabled: false },
    { title: 'Patent Drawing', routerLink: '/main/patentDrawing', disabled: true },
    { title: 'Patent Search', routerLink: '/main/patentSearch', disabled: true },
    { title: 'Patent Drafting', routerLink: '/main/patentDraft', disabled: true },
    { title: 'Preview', routerLink: '/main/preview', disabled: true }
  ]

  constructor(private sesssionActivityService: SesssionActivityService,
    private authService: AuthService) {

  }

  ngOnInit() {
    this.userSession = this.authService.getUserData();
    this.userDetailsId = this.userSession.userDetailsId;
    this.getProjectModules(this.userDetailsId, 6, this.projectId);
  }

  getProjectModules(userId, type, projectId) {

    if (projectId === undefined) {

    }
    else {
      this.sesssionActivityService.getProjectPercentageActiityByUserId(userId, type, projectId).subscribe(
        resp => {
          this.percentage = resp;
          let arrIndexCont = 0;
          if (this.percentage.drawingPercentage == '0') {
            this.stages.splice(1, 1);
          }
          if (this.percentage.inventionPercentage == '100') {
            arrIndexCont++;
          }
          if (this.percentage.drawingPercentage == '100') {
            arrIndexCont++;
          }
          if (this.percentage.searchPercentage == '100') {
            arrIndexCont++;
          }
          if (this.percentage.draftPercentage == '100') {
            arrIndexCont++;
          }
          for (let i = 0; i <= arrIndexCont; i++) {
            this.stages[i].disabled = false;
          }
        }, error => {
          console.log(error);
        })
    }
  }
  removeIndexFromArray(i) {
    return this.stages.pop
  }
}
